import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Main } from '../main/main';
import { CookieConsentService } from 'src/app/services/cookie-consent.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  @Input() main: Main;
  public saleRepName: string;
  public saleRepEmail: string;
  public displayLandingPage = false;
  public contactImageUrl =
    'https://exploreyourscania-assets-eu-west-1-dev.s3.eu-west-1.amazonaws.com/ui-assets/contact_info.png';
  public currentYear = new Date().getFullYear();

  public cookieConsentService = inject(CookieConsentService);

  get additionalFooterText(): string {
    const key = 'eys.additionalFooterText';
    const text = this.translate.instant(key);
    if (text === key) return '';
    return text;
  }

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    // Check if default page
    const pageUrl = window.location.pathname;
    if (pageUrl.toString() == '/') {
      this.displayLandingPage = true;
    } else {
      this.displayLandingPage = false;
      this.saleRepName = this.main.SalesRepFullName;
      this.saleRepEmail = this.main.SalesRepEmail;
    }
  }
}
